import img1 from '../../asset/1.jpg';
import img2 from '../../asset/2.jpg';
import img3 from '../../asset/3.jpg';

 const Data=[
    {
        id:1,
        image:img1,
        title:"Sivani Dubey",
        desc:"A really good job, all aspects of the project he followed step by step thank you.",
    },
    {
        id:2,
        image:img2,
        title:"Ramey",
        desc:"A really good job, he has been delevered really good product as our requirement thank you.",
    },
    {
        id:3,
        image:img3,
        title:"Sohan Raj",
        desc:"I am satisfied for result, he has been delevered really good product as our requirement thank you.",
    }
]
export default Data;